import { memo, useSyncExternalStore } from "react";

import { useModalAria } from "@react/a11y/modalAria";
import { useSectionSettings } from "@react/sections/Root/SectionSettingsContext";
import { ModalProvider } from "@sections/ModalProvider";
import { TablescapeContext } from "@tablescape/context";
import { PageModal } from "@tablescape/state";
import { type TablescapeState } from "@tablescape/state";

import { VideoModalView } from "./VideoModal.view";

type VideoModalSettings = {
  text: {
    closeAriaLabel: string;
  };
};
const VideoModalBase = () => {
  const { videoModal } = useSyncExternalStore<TablescapeState>(
    TablescapeContext.onAll,
    TablescapeContext.getSnapshot
  );

  const {
    text: { closeAriaLabel },
  } = useSectionSettings<VideoModalSettings>();

  const modalAria = useModalAria({
    title: "Video Player",
  });

  return (
    <ModalProvider
      render={({ closeModal, modalProps }) => (
        <VideoModalView
          autoPlay
          closeAriaLabel={closeAriaLabel}
          controls
          fluid
          modalAria={modalAria}
          modalProps={modalProps}
          onClose={closeModal}
          sources={videoModal?.sources}
          subtitles={videoModal?.subtitles}
        />
      )}
      targetModal={PageModal.VIDEO_MODAL}
    />
  );
};

export const VideoModal = memo(VideoModalBase);
